export default {"src":"/_next/static/media/logo.02a8ae63.svg","height":71,"width":189,"blurWidth":0,"blurHeight":0};